"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
// import { OmniChatSchema } from './Schema'
class MoipSecure extends Parse.Object {
    constructor(attributes) {
        super('MoipSecure', attributes);
    }
    get accessToken() { return this.get('accessToken'); }
    set accessToken(value) { this.set('accessToken', value); }
    get percentageFee() { return this.get('percentageFee'); }
    set percentageFee(value) { this.set('percentageFee', value); }
    get fixedFee() { return this.get('fixedFee'); }
    set fixedFee(value) { this.set('fixedFee', value); }
    /**
     * Maximum amount that we are going to charge.
     * Absolute value
     */
    get maxFee() { return this.get('maxFee'); }
    set maxFee(value) { this.set('maxFee', value); }
}
exports.MoipSecure = MoipSecure;
Parse.Object.registerSubclass('MoipSecure', MoipSecure);
//# sourceMappingURL=MoipSecure.js.map